import { render, staticRenderFns } from "./WorksContent.vue?vue&type=template&id=794b6f62&scoped=true&"
import script from "./WorksContent.vue?vue&type=script&lang=js&"
export * from "./WorksContent.vue?vue&type=script&lang=js&"
import style0 from "./WorksContent.vue?vue&type=style&index=0&id=794b6f62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b6f62",
  null
  
)

export default component.exports